import { render, staticRenderFns } from "./Razoes.vue?vue&type=template&id=1bb40122&scoped=true&"
import script from "./Razoes.vue?vue&type=script&lang=js&"
export * from "./Razoes.vue?vue&type=script&lang=js&"
import style0 from "./Razoes.vue?vue&type=style&index=0&id=1bb40122&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb40122",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VTimeline } from 'vuetify/lib'
import { VTimelineItem } from 'vuetify/lib'
installComponents(component, {VCard,VCardTitle,VContainer,VFlex,VIcon,VLayout,VTimeline,VTimelineItem})


/* vuetify-loader */
import installDirectives from "!/opt/build/repo/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Resize } from 'vuetify/lib/directives'
installDirectives(component, {Resize})
